import clsx from 'clsx';
import { gridClasses } from "../constants/index.mjs";
import { useGridPrivateApiContext } from "../hooks/utils/useGridPrivateApiContext.mjs";
import { usePinnedScrollOffset } from "../hooks/utils/usePinnedScrollOffset.mjs";
import { PinnedColumnPosition } from "../internals/constants.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
const classes = {
  root: gridClasses.scrollbarFiller,
  pinnedRight: gridClasses['scrollbarFiller--pinnedRight']
};
function GridScrollbarFillerCell({
  pinnedRight
}) {
  const apiRef = useGridPrivateApiContext();
  const pinnedScrollOffset = usePinnedScrollOffset(apiRef, pinnedRight ? PinnedColumnPosition.RIGHT : undefined);
  return /*#__PURE__*/_jsx("div", {
    role: "presentation",
    className: clsx(classes.root, pinnedRight && classes.pinnedRight),
    style: {
      right: pinnedScrollOffset
    }
  });
}
export { GridScrollbarFillerCell };